import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';
import {Col, Container, Row} from "react-bootstrap"
import android2 from "../assets/img/android.png"
import meter1 from "../assets/img/meter1.svg";
import code from "../assets/img/code.png"
import meter2 from "../assets/img/meter2.svg";
import java from "../assets/img/java.png"
import meter3 from "../assets/img/meter3.svg";
import colorSharp from "../assets/img/color-sharp.png"
import web from "../assets/img/web.png"
import kotlin2 from "../assets/img/kotlin2.png"
import firebase3 from "../assets/img/firebase3.png"
export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };
      return (
        <section className='skills' id='skills'>
            <Container>
                <Row>
                    <Col>
                    <div className='skill-bx'>
                        <h2>
                            Skills
                        </h2>
                        <p> I'm an experienced Android developer proficient in Kotlin, with expertise in building custom UIs, integrating third-party libraries, and connecting to backend APIs. In addition to Kotlin, I'm also skilled in C, Java, Python, web development, and Firebase. With my diverse programming skills, I'm confident in building efficient and high-quality applications that meet your business needs. </p>
                        <Carousel responsive={responsive} infinite={true} className='skill-slider'>
                            <div className='item'>
                                <img src={android2} alt="Image" />
                                <h5> Android Development</h5>
                            </div>
                            <div className='item'>
                               <img src={code} alt="Image" />
                               <h5> Web Development</h5>  
                            </div>
                            <div className='item'>
                                  <img src={kotlin2} alt="Image" />
                                  <h5> Kotlin</h5>
                            </div>
                            <div className='item'>
                                  <img src={java} alt="Image" />
                                  <h5> Java</h5>
                            </div>
                           
                        </Carousel>
                    </div>
                    </Col>
                </Row>
            </Container>
            <img className='background-image-left'src={colorSharp}/>
        </section>
      )
}